import { render, staticRenderFns } from "./EntidadFederativa.vue?vue&type=template&id=0b75e0b6"
import script from "./EntidadFederativa.vue?vue&type=script&lang=js"
export * from "./EntidadFederativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b75e0b6')) {
      api.createRecord('0b75e0b6', component.options)
    } else {
      api.reload('0b75e0b6', component.options)
    }
    module.hot.accept("./EntidadFederativa.vue?vue&type=template&id=0b75e0b6", function () {
      api.rerender('0b75e0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/EntidadFederativa.vue"
export default component.exports